export default __webpack_public_path__ + "static/media/torso-mid-front.49c451cf.png";